<template>
  <div class="code">
    <div class="character" v-for="(n, index) in length">
      <input
        ref="input"
        type="text"
        maxlength="1"
        :value="spaces[index]"
        @input="input($event, index)"
        @paste="paste"
        @keydown="keydown($event, index)"
        :disabled="readonly"
        :readonly="readonly"
      />
    </div>
  </div>
</template>
<style lang="less" scoped>
.code {
  display: grid;
  max-width: 400px;
  grid-template-columns: repeat(6, 1fr);
  margin: 1em auto;
  grid-gap: 12px;

  .character {
    border: 1px solid #dedede;
    border-radius: 5px;
    height: 50px;
    background: white;

    input {
      display: block;
      width: 100%;
      background: transparent;
      height: 100%;
      font-size: 24px;
      line-height: 50px;
      text-align: center;
    }
  }
}
</style>

<script>
export default {
  data() {
    return {
      spaces: [...this.value],
      submitting: false,
    };
  },
  props: {
    length: { type: Number, default: 6 },
    value: { type: String, default: "" },
    readonly: { type: Boolean },
  },
  computed: {
    code() {
      return this.spaces.join("").trim();
    },
  },
  methods: {
    paste(event) {
      const pasted = event.clipboardData.getData("text");
      if (pasted && pasted.match(/^\d{6}$/)) {
        this.spaces = [...pasted];
        this.$refs.input[this.length - 1].focus();
        event.preventDefault();
        this.changed();
      }
    },
    input(event, index) {
      this.$set(this.spaces, index, event.currentTarget.value);
      if (event.inputType === "insertText") {
        if (index < this.length - 1) {
          this.$refs.input[index + 1].focus();
        }
      }
      this.changed();
    },
    keydown(event, index) {
      switch (event.keyCode) {
        case 8: // Backspace
          if (!event.currentTarget.value) {
            this.moveLeft(index);
          }
          break;
        case 37: // Left
          event.preventDefault();
          this.moveLeft(index);
          break;
        case 39: // Right:
          event.preventDefault();
          this.moveRight(index);
          break;
      }
    },
    moveLeft(index) {
      if (index > 0) {
        this.$refs.input[index - 1].focus();
      }
    },
    moveRight(index) {
      if (index < this.spaces.length - 1) {
        this.$refs.input[index + 1].focus();
      }
    },
    clear() {
      this.spaces = new Array(this.length);
      this.changed();
      this.$nextTick(() => {
        this.$refs.input[0].focus();
      });
    },
    changed() {
      this.$emit("input", this.code);
      if (this.code.length === this.length) {
        this.$emit("code", this.code);
      }
    },
  },
  watch: {
    value(newValue) {
      this.spaces = [...newValue];
      if (!newValue) {
        this.$nextTick(() => {
          this.$refs.input[0].focus();
        });
      }
    },
  },
};
</script>
